import { badge } from "./badgeColors";
import { MealType, CreateRecipeInput } from "../types/recipe";

// Map the recipe modal's submit payload to the create/update API shape.
export const toRecipeInput = (recipeData: any): CreateRecipeInput => ({
  name: recipeData.name,
  default_num_of_servings: recipeData.default_num_of_servings,
  description: recipeData.description,
  components: recipeData.components,
  directions: recipeData.directions,
  meal_type: recipeData.meal_type,
  note: recipeData.note,
});

//Get readable label for meal type
export const getMealTypeLabel = (mealType: MealType): string => {
  const labels: Record<MealType, string> = {
    [MealType.MEAL]: "Meal",
    [MealType.BREAKFAST]: "Breakfast",
    [MealType.LUNCH]: "Lunch",
    [MealType.SNACKS]: "Snacks",
    [MealType.DINNER]: "Dinner",
    [MealType.DRINKS]: "Drinks",
    [MealType.DESSERTS]: "Desserts",
  };

  return labels[mealType];
};

// Every meal type deliberately shares one badge colour. A per-type palette
// was written and then flattened; if that is wanted again, give this its
// argument back rather than reinstating the version that sat commented out
// underneath it (it is in git history).
export const getMealTypeColor = (): string => badge("purple");

//Get all meal types with labels for dropdowns
export const getMealTypeOptions = (): Array<{
  value: MealType;
  label: string;
}> => {
  return Object.values(MealType).map((type) => ({
    value: type,
    label: getMealTypeLabel(type),
  }));
};
